// 2026-10-05 addition — explicit request: "confirm delete modal is super
// weird, I need a proper UI modal, not an alert" — window.confirm() is a
// blocking native browser dialog with no styling control at all; this is
// a real MUI Dialog matching the app's own brand chrome, used everywhere
// a destructive confirmation is needed.
import React from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions,
  Button, Box,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const B = { navy: "#00357a", red: "#c0392b" };

export default function ConfirmDialog({
  open, title = "Are you sure?", message, confirmLabel = "Delete", cancelLabel = "Cancel",
  destructive = true, loading = false, onConfirm, onCancel,
}) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth
      PaperProps={{ sx: { borderRadius: "16px" } }}>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1.5, fontFamily: "'Playfair Display', serif", fontWeight: 700 }}>
        <Box sx={{
          width: 36, height: 36, borderRadius: "10px", flexShrink: 0,
          bgcolor: destructive ? "rgba(192,57,43,0.1)" : "rgba(0,53,122,0.08)",
          display: "flex", alignItems: "center", justifyContent: "center",
        }}>
          <WarningAmberIcon sx={{ color: destructive ? B.red : B.navy, fontSize: 20 }} />
        </Box>
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ fontSize: 14.5, color: "#475569" }}>{message}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button onClick={onCancel} disabled={loading}
          sx={{ textTransform: "none", fontWeight: 600, color: "#64748b" }}>
          {cancelLabel}
        </Button>
        <Button onClick={onConfirm} disabled={loading} variant="contained"
          sx={{
            textTransform: "none", fontWeight: 700, borderRadius: "10px",
            bgcolor: destructive ? B.red : B.navy,
            "&:hover": { bgcolor: destructive ? "#a93226" : "#002a61" },
          }}>
          {loading ? "Working…" : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
